/* eslint-disable @typescript-eslint/naming-convention */
import React, { FC } from 'react';
import { t } from 'i18next';
import moment from 'moment';
import { setHours, setMinutes } from 'date-fns';
import { useNonSpammyFieldState } from '@common/hooks';
import { notEmptyValidator } from '@common/utils';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const TIME_INTERVAL = 15;

interface IDropOffTimeField {
  multilegField?: string;
}

const DropOffTimeField: FC<IDropOffTimeField> = ({ multilegField }) => {
  const fieldName = multilegField ? `${multilegField}.dropoff_time` : 'dropoff_time';

  const { value: pickup_time } = useNonSpammyFieldState<Date>(
    multilegField ? `${multilegField}.pickup_time` : 'pickup_time',
  );
  const { value: pickup_date } = useNonSpammyFieldState<Date>(
    multilegField ? `${multilegField}.pickup_date` : 'pickup_date',
  );
  const { value: dropoff_date } = useNonSpammyFieldState<Date>(
    multilegField ? `${multilegField}.dropoff_date` : 'dropoff_date',
  );

  const isSameDate = pickup_date && dropoff_date && moment(pickup_date).isSame(dropoff_date, 'day');
  const minEndTime = moment(pickup_time).add(TIME_INTERVAL, 'minutes');

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-drop-off-time">
      <DateField
        className={css.input}
        dateFormat="HH:mm"
        label={t('bookingDetails.dropoffTime')}
        maxTime={isSameDate ? setHours(setMinutes(new Date(), 45), 23) : undefined}
        minTime={
          isSameDate
            ? setHours(setMinutes(new Date(), minEndTime.minutes()), minEndTime.hour())
            : undefined
        }
        name={fieldName}
        showTimeSelect
        showTimeSelectOnly
        timeCaption={undefined}
        timeFormat="HH:mm"
        timeIntervals={TIME_INTERVAL}
        validate={notEmptyValidator}
      />
    </div>
  );
};

export default DropOffTimeField;
